import { extendTheme } from "@chakra-ui/react";

import {
  semanticColors,
  colors,
  borders,
  borderRadius,
  fontSizes,
  fontWeights,
  lineHeights,
  space,
  sizes,
  textStyles,
  shadows,
  breakpoints,
} from "./foundations";
import { Button, Heading, Text } from "./components";
import { styles } from "./styles";

export const theme = extendTheme({
  fonts: {
    heading: "Poppins, sans-serif",
    body: "Poppins, sans-serif",
  },
  semanticTokens: {
    colors: semanticColors,
  },
  colors,
  borders,
  styles,
  radii: borderRadius,
  fontSizes,
  fontWeights,
  lineHeights,
  space,
  sizes,
  textStyles,
  shadows,
  breakpoints,
  components: {
    Button,
    Heading,
    Text,
  },
});
